module.exports = __webpack_public_path__ + "img/2.22f2aadd.jpg";